import { ApiError } from '@shared/api';
import { i18n } from '@shared/i18n';

export function mapAuthError(error: unknown): string {
  if (!(error instanceof ApiError)) return i18n.t('auth.errors.generic');
  switch (error.code) {
    case 'AUTHENTICATION_FAILED':
      return i18n.t('auth.errors.invalidCredentials');
    case 'RATE_LIMITED':
      return i18n.t('auth.errors.rateLimited');
    case 'CONFLICT':
      return i18n.t('auth.errors.alreadyRegistered');
    default:
      return error.message || i18n.t('auth.errors.generic');
  }
}
